import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, Prazo } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class PrazoService extends BaseResourceService<Prazo> {

  constructor(
    protected injector: Injector
  ) {
    super(`prazos`, injector);
  }

}
